import { OpenGraphMedia } from 'next-seo/lib/types';
import { ImageObject } from 'schema-dts';

export const MR_SCHEMA = {
  organizationName: 'Mais Retorno',
  organizationTitle:
    'Mais Retorno - Tudo sobre Fundos de Investimentos, Renda Fixa e Renda Variável',
  organizationAlternateName: 'MR',
  organizationTelephone: '40072927',
  organizationLogoWidth: 60,
  organizationLogoHeight: 60,
  organizationLogo:
    'https://maisretorno.com/assets/logo-mais-retorno-google-news-60x60.png',
  organizationDescription:
    'A Mais Retorno é um portal completo sobre o mercado financeiro, com notícias diárias sobre tudo o que acontece na economia, nos investimentos e no mundo. Além de produzir colunas semanais, termos sobre o mercado e disponibilizar uma ferramenta exclusiva sobre os fundos de investimentos, com mais de 35 mil opções é possível realizar analises detalhadas através de índices, indicadores, rentabilidade histórica, composição do fundo, quantidade de cotistas e muito mais!',
  organizationUrl: 'https://www.maisretorno.com',
  organizationAddressCountry: 'BR',
  organizationPostalCode: '01301-000',
  organizationLocality: 'São Paulo, Brasil',
  organizationStreetAddress: 'R. da Consolação, 2302 - Consolação',
  organizationSocialNetworks: [
    'https://www.instagram.com/mais_retorno/',
    'https://www.facebook.com/maisretorno',
    'https://www.linkedin.com/company/maisretorno',
    'https://www.youtube.com/maisretorno',
    'https://twitter.com/mais_retorno',
  ],
  organizationInstagam: 'https://www.instagram.com/mais_retorno',
  organizationFacebook: 'https://www.facebook.com/maisretorno',
  organizationLinkedin: 'https://www.linkedin.com/company/maisretorno',
  organizationYoutube: 'https://www.youtube.com/maisretorno',
  organizationTwitter: 'https://twitter.com/mais_retorno',
  organizationLocale: 'pt_BR',
};

export const ORGANIZATION_SCHEMA = JSON.stringify({
  '@context': 'https://schema.org',
  '@type': 'NewsMediaOrganization',
  name: MR_SCHEMA.organizationName,
  description: MR_SCHEMA.organizationDescription,
  url: MR_SCHEMA.organizationUrl,
  alternateName: MR_SCHEMA.organizationAlternateName,
  logo: MR_SCHEMA.organizationLogo,
  telephone: MR_SCHEMA.organizationTelephone,
  address: {
    '@type': 'PostalAddress',
    addressLocality: MR_SCHEMA.organizationLocality,
    addressCountry: MR_SCHEMA.organizationAddressCountry,
    postalCode: MR_SCHEMA.organizationPostalCode,
    streetAddress: MR_SCHEMA.organizationStreetAddress,
  },
  sameAs: MR_SCHEMA.organizationSocialNetworks,
});

export const ORGANIZATION_SCHEMA_TO_NEWS = JSON.stringify({
  '@context': 'https://schema.org',
  '@type': 'NewsMediaOrganization',
  name: MR_SCHEMA.organizationName,
  description: MR_SCHEMA.organizationDescription,
  url: MR_SCHEMA.organizationUrl,
  alternateName: MR_SCHEMA.organizationAlternateName,
  logo: MR_SCHEMA.organizationLogo,
  telephone: MR_SCHEMA.organizationTelephone,
  sameAs: MR_SCHEMA.organizationSocialNetworks,
});

export const SEO_FALLBACK_IMAGE: ImageObject = {
  '@type': 'ImageObject',
  name: 'Logo Mais Retorno',
  url: 'https://maisretorno.com/api/nextjs/resize-image?src=https://maisretorno.com/assets/mr-logo-bgazul-1000x1000-1629306429.png&w=1200&h=675',
  height: '675',
  width: '1200',
};

export const OPEN_GRAPH_IMAGE: OpenGraphMedia = {
  url: 'https://maisretorno.com/api/nextjs/resize-image?src=https://maisretorno.com/assets/mr-logo-bgazul-1000x1000-1629306429.png&w=1200&h=675',
  height: 675,
  width: 1200,
  type: 'image/png',
  alt: 'Logo Mais Retorno',
};
